import basicController from "servicestack/basic.controller.properties";
import labels from "emun.customer/_labels";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";

export default class CustomerVendorController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
    $ctrl.labels = labels;
    //console.info("$ctrl.request", $ctrl.request);
    //console.info("$ctrl.type", $ctrl.type);
    //console.info("$ctrl.savetype", $ctrl.saveType);
		$ctrl.bus
			.send("QueryVendors.json?Active=1")
			.then(function(res) {
        $ctrl.vendors = res.data.results;
      });

    $ctrl.bus
      .send("QuerySalesRepList.json?Active=1&OrderBy=name")
      .then(function (res) {
        $ctrl.reps = res.data.results;
      });

    $ctrl.bus
      .send("QueryPaymentTerms.json")
      .then(function (res) {
        $ctrl.terms = res.data.results;
      });

    $ctrl.bus
      .send("QueryRepGroups.json")
      .then(function (res) {
        $ctrl.repGroups = res.data.results;
      });

    if ($ctrl.type == "Location") {
      $ctrl.bus
        .send("QueryRetailerShippingLocations.json?retailerid=" +
          $ctrl.customer.id)
        .then(function (res) {
          $ctrl.locations = res.data.results;
        });
    }
	}

  loadVendors() {
    const $ctrl = this;
    console.debug("$ctrl.showInactiveVendors", $ctrl.showInactiveVendors);
    var queryString = "?Active=1&OrderBy=Label";
    if ($ctrl.showInactiveVendors) {
      queryString = "?IncludeInActive=1&OrderBy=Label";
    }
    $ctrl.bus
      .send("QueryVendors.json" + queryString)
      .then(function (res) {
        $ctrl.vendors = res.data.results;
      });
  }

	submit() {
    const $ctrl = this;
    if ($ctrl.saveType == undefined || $ctrl.saveType != "Update") {
      $ctrl.saveType = "Create";
    }
    if ($ctrl.request.repGroupId == null) {
      $ctrl.request.repGroupId = "";
    }
    //console.info("$ctrl.type", $ctrl.type);
    if ($ctrl.type == "Customer") {
      $ctrl.bus.send($ctrl.saveType + "RetailerVendor.json", $ctrl.request).then(
        function (response) {
          $ctrl.$close()
        },
        function (response) {
          if (response.data.responseStatus.errorCode)
            modals.alert(response.data.responseStatus.message);
        }
      );
    } else if ($ctrl.type == "Location") {
      $ctrl.bus.send($ctrl.saveType + "RetailerVendorLocation.json", $ctrl.request).then(
        function (response) {
          $ctrl.$close()
        },
        function (response) {
          if (response.data.responseStatus.errorCode)
            modals.alert(response.data.responseStatus.message);
        }
      );
    }
    
	}
}
